import { Component , Output,EventEmitter} from '@angular/core';
import Swal from "sweetalert2";
import { MessagesTitles,MessagesStatus} from '../../../models/messages';
import { Router,ActivatedRoute  } from '@angular/router';
import { CobranzasService } from '../../../services/cobranzas/cobranzas.service';
import {HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup} from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { LoginService} from '../../../services/login/login.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-editar-adquirente',
  templateUrl: './editar-adquirente.component.html',
  styleUrls: ['./editar-adquirente.component.scss'],
  providers:[MessagesTitles,MessagesStatus]
})
export class EditarAdquirenteComponent   {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;

  @Output() cerrarEditar = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<any>();
  adquirentesArr:any;
  idAdquirente :any;
  rucAdq = new FormControl();
  filteredAdquirente: Observable<any[]>;
  formAdjunto : FormGroup;
  idCobranzaPago : any;
  deposito : any;
  subTitle : any;
  loading:boolean = false;

  constructor(private loginService:LoginService,private routerActive:ActivatedRoute,private cobranzasService:CobranzasService,private router:Router,private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus){


  try {
      this.idCobranzaPago = this.cobranzasService.idCobranzaPago;
      this.deposito = this.cobranzasService.deposito;
      
        this.subTitle = "Depósito Importe : ";
         this.cobranzasService.idCobranzaPago = '';
         this.formAdjunto = new FormGroup({
              'idEmpresa' : new FormControl(''),
              'idCobranza' : new FormControl('')
           })

           this.ObtenerAdquirentesCombo();
    }catch (error) {
      this.cerrarEditar.emit();
    }
  }


  obtenerRucRazSocialAdq(termino :string = ''){  
    if (termino != null && termino != ''){       
      let termino1 = termino.toLowerCase();                   
      for( let p of this.adquirentesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){         
            this.idAdquirente = p.idEmpresa;
          }
      }
    }
  }
  
  ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirente = this.rucAdq.valueChanges
    .pipe(
      startWith(""),
      map(state =>
        state ? this._filterAdq(state) : this.adquirentesArr.slice()
      )
    ); 
  }
  
  private _filterAdq(value: string): any[] {
  const filterValue = value.toString().toLowerCase();
  return this.adquirentesArr.filter(
    state => state.Razon_Social.toLowerCase().includes(filterValue) === true
  );
  }
  
  obtenerIdAdq(termino :string){
    this.idAdquirente = termino;
  }
  
  guardarAdquirente(){
  
    this.formAdjunto.controls['idEmpresa'].setValue(this.idAdquirente);
    this.formAdjunto.controls['idCobranza'].setValue(this.idCobranzaPago);
  
    Swal.fire({
      title: 'Espere',
      text:'Guardado Información',
      type:'info',
      allowOutsideClick:false,
      heightAuto: false
    });
    Swal.showLoading();
    this.cobranzasService.ActualizarAdquirentePago(this.formAdjunto.getRawValue())
        .subscribe(resp => {
          Swal.fire({
            title: "Felicidades",
            text: "Adquirente actualizado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res =>{
            if (res.value == true ){
              this.cerrarEditar.emit();
              this.refresh.emit();          
            }
          });
        },(err: HttpErrorResponse)=> {  
          this.msgStatus.getMessage(err.status); 
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "ADQUIRENTE NO ACTUALIZADO. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        }); 
  }

  CerrarPopUp(){
    this.cerrarEditar.emit();
  }

}
